import { FETCH_ALL_INFORMATION_FAILURE, FETCH_ALL_INFORMATION_REQUEST, FETCH_ALL_INFORMATION_SUCCESS } from './allInformation.actionsType';

export const ALL_INFORMATION = 'allInformation';

let initialState = {
    loading: false,
    allInfo: [],
    errorMessage: ''
};

export let allInformationReducer = (state = initialState, action) => {
    let { type, updatePayload } = action;
    switch (type) {
        case FETCH_ALL_INFORMATION_REQUEST:
        case FETCH_ALL_INFORMATION_SUCCESS:
            return {
                ...state,
                loading: false,
                allInfo: updatePayload
            };
        case FETCH_ALL_INFORMATION_FAILURE:
        default:
            return state;
    }
};
